import { ListStatus, EditableStatus } from '@/store/types';
import Pagination from '@/store/models/pagination';
import Region from '@/store/models/region';
import i18n from '@/i18n';

export enum RegionStatus {
  Inactive = 0,
  Active = 1,
}

export const RegionStatuses = {
  [RegionStatus.Inactive]: i18n.t('Inactive'),
  [RegionStatus.Active]: i18n.t('Active'),
};

export enum RegionsActions {
  /**
   * Edit
   */
  LOAD_EDITABLE = 'LOAD_EDITABLE',
  UPDATE_EDITABLE = 'UPDATE_EDITABLE',
  SAVE_EDITABLE = 'SAVE_EDITABLE',
}

export enum RegionsMutations {
  /**
   * Edit
   */
  SET_EDITABLE = 'SET_EDITABLE',
  SET_EDITABLE_STATUS = 'SET_EDITABLE_STATUS',
  UPDATE_EDITABLE = 'UPDATE_EDITABLE',
  UPDATE_INITIAL_EDITABLE = 'UPDATE_INITIAL_EDITABLE',
}

export interface RegionsState {
  /**
   * Edit
   */
  editable?: Region[];
  initialEditable?: Region[];
  editableStatus: EditableStatus;
}
